import { BASE_URL, FREE_BASE_URL } from "../BaseUrl.js";
import axios from "axios";

axios.interceptors.request.use(function (config) {
  const token = localStorage.getItem("cc_pssm_api");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  } else {
    config.headers.Authorization = null;
  }

  return config;
}, function (error) {
  console.log('AN ERROR REQUEST', error)
});

const currentAnnee = localStorage.getItem("currentAnnee")
  ? JSON.parse(localStorage.getItem("currentAnnee"))
  : null;

export const listeDesModePaiementPaginee = async (page = 1, size = 10, param = "") => {  
  return await axios.get(
    BASE_URL(`mode-paiement/query?page=${page}&size=${size}&param=${param}`),
    {}
  );
};

export const listeCompleteDesModePaiements = async () => {
  return await axios.get(
    FREE_BASE_URL(`mode-paiement`),
    {}
  );
};

export const listeCompleteDesModePaiementsParAnnee = async (anneeId) => {
  return await axios.get(
    BASE_URL(`mode-paiement`),
    {}
  );
};

export const recupereModePaiementParSonId = async (commissionId) => {
  return await axios.get(
    BASE_URL(`mode-paiement/${commissionId}`),
    {}
  );
};

export const ajouterUneModePaiement = async (values) => {
  return await axios.post(
    BASE_URL(`mode-paiement`),
    values
  );
};

export const modifierUneModePaiement = async (values, commissionId) => {
  return await axios.put(
    BASE_URL(`mode-paiement/${commissionId}`),
    values
  );
};

export const supprimerUneModePaiement = async (commissionId) => {
  return await axios.delete(
    BASE_URL(`mode-paiement/${commissionId}`),
    {}
  );
};
